<!-- Vertical layout -->
<app-vertical *ngIf="layoutType === layoutVars.VER"></app-vertical>
<app-horizontal *ngIf="layoutType === layoutVars.HOR"></app-horizontal>
<app-general-loader></app-general-loader>